import React from "react";
import { Row, Col, Table, Typography, Space } from "antd";
import "./InvitationToPDF.css";
import LogoForPDF from "../../../svg/svgicon/LogoForPDF";
import DocumentIcon from "../../../svg/svgicon/DocumentIcon";
import { API } from "../../../API/API";
const { Text } = Typography;
const Str = require("@supercharge/strings");
class InvitationToPDF extends React.Component {
  state = {
    invitationid: this.props.invitationid,
    tendername: this.props.tendername,
    balanceday: "",
    tendercode: "",
    invitationcode: "",
    startdate: "",
    enddate: "",
    departmentname: "",
    tendertypename: "",
    criterialist: [],
    requirelist: [],
    email: "",
    address: "",
    phone: "",
    tenderdoclist: [],
    tenderBatch: [],
    commentlist: [],
    post: "",
    electron: "",
    text: [],
    dkey: 1,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("/getInvitationDtl?invitationid=" + this.state.invitationid).then(
      (response) => {
        if (response.status === 200) {
          if (response.data.retData.length > 0) {
            this.setState((prevState) => ({
              tendername: response.data.retData[0][0].tendername,
              departmentname: response.data.retData[0][0].departmentname,
              tendertypename: response.data.retData[0][0].tendertypename,
              tendercode: response.data.retData[0][0].tendercode,
              invitationcode: response.data.retData[0][0].invitationcode,
              description: response.data.retData[0][0].description,
              text: Str(response.data.retData[0][0].description).lines(),
              startdate: response.data.retData[0][0].startdate,
              enddate: response.data.retData[0][0].enddate,
              balanceday: response.data.retData[0][0].balanceday,
              criterialist: response.data.retData[1],
              requirelist: response.data.retData[2],
              address:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].address
                  : "",
              email:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].email
                  : "",
              phone:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].phone
                  : "",
              electron:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].electron === 1
                    ? "Цахим"
                    : ""
                  : "",
              post:
                response.data.retData[3].length > 0
                  ? response.data.retData[3][0].post === 1
                    ? "Хаягаар ирүүлэх"
                    : ""
                  : "",
              tenderdoclist: response.data.retData[4],
              tenderBatch: response.data.retData[5],
              commentlist: response.data.retData[6],
              dkey: prevState.dkey + 1,
            }));
          }
        }
      }
    );
  };
  // getData = () => {
  //   if (this.props.data) {
  //     if (this.props.data.length > 0) {
  //       if (this.props.data[0].length > 0){
  //         this.setState((prevState) => ({
  //           description: this.props.data[0][0].description !== undefined ? this.props.data[0][0].description : null,
  //           startdate: this.props.data[0][0].startdate !== undefined ? this.props.data[0][0].startdate : null,
  //           enddate: this.props.data[0][0].enddate !== undefined ? this.props.data[0][0].enddate : null,
  //           acceptdate: this.props.data[0][0].acceptdate !== undefined ? this.props.data[0][0].acceptdate : null,
  //           criterialist: this.props.data[1],
  //           requirelist: this.props.data[2],
  //           dkey: prevState.dkey + 1,
  //         }));
  //       }
  //       if (this.props.data[3].length > 0) {
  //         this.setState((prevState) => ({
  //           address: this.props.data[3][0].address,
  //           email: this.props.data[3][0].email,
  //           phone: this.props.data[3][0].phone,
  //           electron: this.props.data[3][0].electron === 1 ? "Цахим" : "",
  //           post: this.props.data[3][0].post === 1 ? "Хаягаар ирүүлэх" : "",
  //           dkey: prevState.dkey + 1,
  //         }));
  //       }
  //     }
  //   }
  // };
  render() {
    const columnBatch = [
      {
        title: "Багцын код",
        dataIndex: "batchcode",
        key: "batchcode",
        width: "45%",
        align: "left",
      },
      {
        title: "Багцын нэр",
        dataIndex: "batchname",
        key: "batchname",
        width: "45%",
        align: "left",
      },
    ];
    return (
      <div
        style={{ padding: 10 }}
        key={this.state.dkey}
        id="invitationOfTender"
      >
        <div style={{ backgroundColor: "#fff" }}>
          <Row justify="center" align="middle">
            <Col style={{ marginTop: -20, marginRight: 20 }}>
              <LogoForPDF />
            </Col>
            <Col>
              <div className="PDFHeaderLabel">MONGOLYN ALT (MAK)</div>
            </Col>
          </Row>
          <Row style={{ marginTop: -10 }} justify="center">
            <div className="PDFSubHeaderLabel">CORPORATION</div>
          </Row>
          <div style={{ padding: 10 }}>
            <div className="HeaderLabel" style={{ marginBottom: 10 }}>
              {this.state.tendername}
            </div>
            <div>
              <Row gutter={(16, 16)}>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">Захиалагч:</div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">
                    Монголын алт ХХК - Хангамж техник үйлчилгэээний газар
                  </div>
                </Col>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">
                    Тендер шалгаруулалтын төрөл:
                  </div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">
                    {this.state.tendertypename}
                  </div>
                </Col>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">
                    Тендер шалгаруулалтын дугаар:
                  </div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">
                    {this.state.tendercode}
                  </div>
                </Col>
                <Col className="headerTable-leftSide" span={12}>
                  <div className="headerTable-leftSide-Text">
                    Урилгын дугаар:
                  </div>
                </Col>
                <Col className="headerTable-rightSide" span={12}>
                  <div className="headerTable-rightSide-Text">
                    {this.state.invitationcode}
                  </div>
                </Col>
              </Row>
              <div className="content-Text" style={{ marginTop: 15 }}>
                <Space direction="vertical">
                  {this.state.text.map((value) => (
                    <Text>{value}</Text>
                  ))}
                </Space>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                КОМПАНИД ТАВИГДАХ ШААРДЛАГА
              </div>
              {this.state.criterialist.map((el, index) => (
                <div
                  key={index}
                  className="content-Text"
                  style={{ marginLeft: 10 }}
                >
                  {index + 1}. {el.criteriatypename}
                </div>
              ))}
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                БҮРДҮҮЛЭХ МАТЕРИАЛЫН ЖАГСААЛТ
              </div>
              {this.state.requirelist.map((el, index) => (
                <div
                  key={index}
                  className="content-Text"
                  style={{ marginLeft: 10 }}
                >
                  {index + 1}. {el.requirevalue}
                </div>
              ))}
              <div style={{ marginTop: 20 }}>
                <text style={{ fontWeight: 700 }}>
                  Хамтран ажиллах саналын материалыг
                </text>{" "}
                {this.state.enddate} хүртэл{" "}
                {this.state.electron !== "" && this.state.post !== ""
                  ? this.state.electron +
                    " болон " +
                    this.state.post +
                    " хэлбэрээр "
                  : this.state.electron !== "" || this.state.post !== ""
                  ? this.state.electron + " " + this.state.post + " хэлбэрээр "
                  : null}{" "}
                хүлээн авна.
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                Хаяг:{" "}
                <text style={{ fontWeight: 400 }}>{this.state.address}</text>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                И-мэйл:{" "}
                <text style={{ fontWeight: 400 }}>{this.state.email}</text>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                Вэб сайт: <text style={{ fontWeight: 400 }}>www.mak.mn</text>
              </div>
              <div className="content-Text-Bold" style={{ marginTop: 15 }}>
                Утас:{" "}
                <text style={{ fontWeight: 400 }}>{this.state.phone}</text>
              </div>
              {this.state.tenderBatch.length > 0 ? (
                <div>
                  <Row
                    className="documentHeader"
                    justify="start"
                    align="middle"
                  >
                    <Col>
                      <DocumentIcon />
                    </Col>
                    <Col>
                      <div
                        className="documentHeader-Text"
                        style={{ marginLeft: 10 }}
                      >
                        Тендерийн багц
                      </div>
                    </Col>
                  </Row>
                  <div style={{ marginRight: 15 }}>
                    <Table
                      dataSource={this.state.tenderBatch}
                      columns={columnBatch}
                      pagination={false}
                      rowKey="docid"
                    />
                  </div>{" "}
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      // <div style={{ padding: 10 }} key={this.state.dkey}>
      //   <Row justify="center" align="middle">
      //     <Col style={{ marginTop: -20, marginRight: 20 }}>
      //       <LogoForPDF />
      //     </Col>
      //     <Col>
      //       <div className="PDFHeaderLabel">MONGOLYN ALT (MAK)</div>
      //     </Col>
      //   </Row>
      //   <Row style={{ marginTop: -10 }} justify="center">
      //     <div className="PDFSubHeaderLabel">CORPORATION</div>
      //   </Row>
      //   <Row style={{ marginTop: 20 }} justify="center">
      //     <div className="PDFTitleLabel">{this.state.tendername}</div>
      //   </Row>
      //   <Row style={{ marginTop: 20 }} justify="center">
      //     <div className="PDFContentLabel">{this.state.description}</div>
      //   </Row>
      //   <Row style={{ marginTop: 20, marginBottom: 10 }} justify="start">
      //     <div className="PDFContentTitleLabel">
      //       КОМПАНИД ТАВИГДАХ ШААРДЛАГА
      //     </div>
      //   </Row>
      //   {this.state.criterialist.map((el, index) => (
      //     <Row style={{}} justify="start">
      //       <div className="PDFContentLabel" style={{ marginLeft: 20 }}>
      //         <p key={index}>
      //           {index + 1}. {el.criteriatypename}
      //         </p>
      //       </div>
      //     </Row>
      //   ))}
      //   <Row style={{ marginTop: 10, marginBottom: 10 }} justify="start">
      //     <div className="PDFContentTitleLabel">
      //       БҮРДҮҮЛЭХ МАТЕРИАЛЫН ЖАГСААЛТ
      //     </div>
      //   </Row>
      //   {this.state.requirelist.map((el, index) => (
      //     <Row style={{}} justify="start">
      //       <div className="PDFContentLabel" style={{ marginLeft: 20 }}>
      //         <p key={index}>
      //           {index + 1}. {el.requirevalue}
      //         </p>
      //       </div>
      //     </Row>
      //   ))}
      //   <Row style={{ marginTop: 20 }} justify="start">
      //     <div className="PDFContentLabel">
      //       <text style={{fontWeight: 500}}>Хамтран ажиллах саналын материалыг</text> {this.state.acceptdate} хүртэл {this.state.electron !== "" || this.state.post !== "" ? this.state.electron + " " + this.state.post + " хэлбэрээр " : null} хүлээн авна.
      //     </div>
      //   </Row>
      //   <Row style={{ marginTop: 20 }} justify="center">
      //     <div
      //       className="PDFContentLabel"
      //       style={{
      //         textAlign: "center",
      //         paddingLeft: 80,
      //         paddingRight: 80,
      //         fontWeight: "bold",
      //       }}
      //     >
      //       Хаяг: {this.state.address}
      //     </div>
      //   </Row>
      //   <Row justify="center">
      //     <div className="PDFContentLabel" style={{ fontWeight: "bold" }}>
      //       И-мэйл: {this.state.email}
      //     </div>
      //   </Row>
      //   <Row justify="center">
      //     <div className="PDFContentLabel" style={{ fontWeight: "bold" }}>
      //       Веб сайт: www.mak.mn
      //     </div>
      //   </Row>
      //   <Row justify="center">
      //     <div className="PDFContentLabel" style={{ fontWeight: "bold" }}>
      //       Утас: {this.state.phone}
      //     </div>
      //   </Row>
      // </div>
    );
  }
}

export default InvitationToPDF;
